import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import {Paper} from "@mui/material";
import SnackbarContext from "../../../Context/SnackbarContext";
import {getPipelines} from "../../../Services/Company/PipelineService";
import BoardForm from '../../../Components/Forms/Pages/Boards/BoardForm';
import { PipelineType } from '../../../Constants/Company/PipelineType';
import { editBoard, getBoardKeyExists } from '../../../Services/Workspaces/BoardsService';
import { getProjectList } from '../../../Services/Project/ProjectService';
import { isSpecialCharacter } from '../../../Util/Validation';

const formRules = {
    'name': {required: true},
    'pipeline': {required: true},
	'boardKey': {required: { value: true, message: strings.forms.common.thisFieldIsRequired}},
}

const EditBoard = (props) => {
	const {setDrawerTitle} = useContext(DrawerContext);
	const { showMessage } = useContext(SnackbarContext);
	const [showLoader, setShowLoader] = useState(false);
	const [pipelines, setPipelines] = useState([]);
	const [projects, setProjects] = useState([]);
	const form = useForm({
			defaultValues: 
			{
					name: props.board?.name,
					description: props.board?.description,
					pipeline: props.board?.pipeline,
					project: props.board?.project,
					boardKey: props.board?.boardKey,
			}
	});
	const {data, handleSubmit, getValues, setValue, setError, formState: {errors}, control} = form;

	useEffect(() => {
			setDrawerTitle(strings.pages.boards.editBoards.pageTitle);
	},[]);

	const onSubmit = (data) => {

		if (!isSpecialCharacter(data.boardKey)) {
			setError('boardKey', {message: strings.forms.board.cantUseSpecialChar} );
			return;
		}

		setShowLoader(true);

		const sameBoardKey = props.board.boardKey.toLowerCase() != data.boardKey.toLowerCase()

		getBoardKeyExists(data).then((response) => {
			
			if((!response || !response.ok) && sameBoardKey) {
				showMessage(strings.commonMessages.errorEditing, 'error');
				setError('boardKey', {message: strings.forms.board.boardKeyExists} );
				setShowLoader(false);
				return;
			}

			editBoard(props.board.id, data).then(response => {
				setShowLoader(false);
				if(!response || !response.ok) {
						showMessage(strings.commonMessages.errorEditing, 'error');
						props.onFinish();
						return;
				}

				showMessage(strings.commonMessages.editingSuccessful, 'success');
				props.onFinish();
			});

		});
		
	}

	const fetchPipelines = (term = '') => {
			getPipelines({
				term: term,
				type: PipelineType.TASK,
			}).then(response => {
					setPipelines(response.data?.result);
			});
	}

	const fetchProjects = (term = '') => {
		getProjectList({
			term
		}).then( response => {
			setProjects(response.data?.result);
		});
	}

	return (
			<div className = 'drawer-form'>
					<Paper className = 'paper'>
							{
									showLoader &&
											<LinearProgress />
							}
							<BoardForm 
									formRules = {formRules}
									form = {form}
									values = {getValues()}
									setValue = {setValue}
									data = {data}
									errors = {errors}
									onSubmit = {handleSubmit(onSubmit)}
									onCancel = {() => props.onCancel()}
									pipelines = {pipelines}
								  projects = {projects}
									control = {control}
									onChangePipelineFilter = {fetchPipelines}
									onChangeProjectFilter = {fetchProjects}
							/>
					</Paper>
			</div>
	);

}

export default EditBoard;
